// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"arrow-left-down"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M15.7782 16.0257H8L8 8.24748M8.87946 15.1462L16.0257 8","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const ArrowLeftDownIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'arrow-left-down',
    ref,
    icon: element,
  },
));

ArrowLeftDownIcon.displayName = 'ArrowLeftDownIcon';

export default ArrowLeftDownIcon;
